import React from 'react';

const ListIcon = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9583 6.59174V4.10675C11.9583 1.75592 11.41 1.16675 9.20496 1.16675H4.79496C2.58996 1.16675 2.04163 1.75592 2.04163 4.10675V10.6751C2.04163 12.2267 2.8933 12.5942 3.9258 11.4859L3.93162 11.4801C4.40995 10.9726 5.13912 11.0134 5.55329 11.5676L6.14246 12.3551"
      stroke="#3BF2A2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66663 4.08325H9.33329"
      stroke="#3BF2A2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 6.41675H8.75"
      stroke="#3BF2A2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6231 8.61599L8.55814 10.681C8.47647 10.7627 8.40063 10.9143 8.38313 11.0252L8.27229 11.8127C8.23146 12.0985 8.4298 12.2968 8.71563 12.256L9.50314 12.1452C9.61397 12.1277 9.77147 12.0518 9.8473 11.9702L11.9123 9.90517C12.2681 9.54934 12.4373 9.13517 11.9123 8.61017C11.3931 8.09101 10.979 8.26016 10.6231 8.61599Z"
      stroke="#3BF2A2"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3246 8.91357C10.4996 9.54357 10.9896 10.0336 11.6196 10.2086"
      stroke="#3BF2A2"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ListIcon;
